/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const ApiAccountsMeRetrieveParams = zod.strictObject({
    format: zod.enum(['csv', 'json']).optional(),
});

export type ApiAccountsMeRetrieveParams = zod.input<
    typeof ApiAccountsMeRetrieveParams
>;
export type ApiAccountsMeRetrieveParamsOutput = zod.output<
    typeof ApiAccountsMeRetrieveParams
>;
